import { CURRENCY, LOCALE } from 'config/app'

export const format = (value) => `${new Intl.NumberFormat(LOCALE).format(value)} ${CURRENCY}`

export const symbol = format(0).replace(/[\d,\.]+/g, '')
